module.exports = __webpack_public_path__ + "img/dokumen-wajib-active.e7a3ffa3.svg";